<template>
  <Header/>
  <div id="content" style="height: 100%;">
    <router-view/>
  </div>
  <Footer/>
  <div class="modal fade" id="version-modal" tabindex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
            </div>
            <div class="modal-body">
                <div class="d-flex flex-column w-100 px-3">
                  <div class="d-flex flex-column justify-content-center align-items-center mb-3">
                    <span><Icon name="alert-triangle" :size="32" class="warning" /></span>
                  </div>
                  <div class="d-flex flex-column justify-content-center align-items-center text-center">
                    <span class="poppins-bold fs-6 mb-1">{{$t("alert.error.versionMissmatch")}}</span>
                  </div>
                </div>
            </div>
            <div class="modal-footer pb-3">
                <div class="d-flex flex-row justify-content-center align-intems-center w-100">
                  <button type="submit" @click="reload()" class="btn btn-outline-primary btn-small mx-3">
                    {{$t("content.confirm")}}
                  </button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/layout/header/Header.vue';
import Footer from '@/components/layout/footer/Footer.vue';
import {Modal} from "bootstrap";

export default {
  data() {
    return {
        versionModalObj: undefined
    }
  },
  mounted() {
    this.versionModalObj = new Modal(document.getElementById('version-modal'), {backdrop: 'static', keyboard: false});
    this.$store.dispatch('getVersion');
  },
  computed: {
    versionError() {
        let error = this.$store.getters['getIsDiffVer'];
        return error;
    }
  },
  watch: {
    versionError(newVal) {
        if (newVal) {
            this.versionModalObj.show();
        }
    }
  },
  methods: {
    reload() {
        location.reload();
    }
  },
  components: {
    Header,
    Footer,
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<!-- Global styles have been moved to src/assets/scss/main.scss -->
